<!-- meeting can be detached and team becomes null, which will cause error in the auth check below -->
<div *ngIf="meeting.team"
     class="d-flex gap-1">
    <a *adaptIfAuthorised="ViewTeamMeetings;Entity:meeting.team"
       [routerLink]="(teamMeetingLink$ | async)?.path"
       [queryParams]="(teamMeetingLink$ | async)?.queryParams"
       class="btn btn-blank meeting-shortcut-icon"
       adaptButtonIcon="fal fa-calendar-lines-pen"
       [adaptTooltip]="!showText ? 'Meeting page' : ''"
       data-test="meeting-page-shortcut">
        <span *ngIf="showText">Team meetings</span>
    </a>

    <a *adaptIfAuthorised="ViewTeamKanban;Entity:meeting.team"
       [routerLink]="(teamWorkUrl$ | async)?.path"
       class="btn btn-blank meeting-shortcut-icon"
       adaptButtonIcon="fal fa-columns"
       [adaptTooltip]="!showText ? 'Team actions' : ''"
       data-test="meeting-tab-details-team-actions">
        <span *ngIf="showText">Team actions</span>
    </a>

    <!-- no need for *adaptIfAlto as they shouldn't have team objectives read -->
    <a *adaptIfAuthorised="ReadObjectivesForTeam;Entity:meeting.team"
       [routerLink]="(teamObjectivesLink$ | async)?.path"
       class="btn btn-blank meeting-shortcut-icon"
       adaptButtonIcon="fal fa-users"
       [adaptTooltip]="!showText ? 'Team objectives' : ''">
        <span *ngIf="showText">Team objectives</span>
    </a>

    <a *adaptIfAuthorised="ReadPublicObjectives"
       [routerLink]="(orgObjectivesLink$ | async)?.path"
       class="btn btn-blank meeting-shortcut-icon"
       adaptButtonIcon="fal fa-cubes"
       [adaptTooltip]="!showText ? orgObjectivesText : ''">
        <span *ngIf="showText">{{orgObjectivesText}}</span>
    </a>

    <ng-container *ngIf="meeting.team.teamType === TeamType.Leadership || meeting.team.teamType === TeamType.Owner">
        <a *adaptIfAuthorised="ReadStrategicGoals"
           [routerLink]="(strategicGoalsUrl$ | async)?.path"
           class="btn btn-blank meeting-shortcut-icon"
           adaptButtonIcon="fal fa-bullseye"
           [adaptTooltip]="!showText ? 'Strategic goals' : ''">
            <span *ngIf="showText">Strategic goals</span>
        </a>
    </ng-container>

    <button *ngIf="canEditTeamMeeting"
            adaptButtonIcon="fal fa-money-check-edit"
            class="ms-auto btn btn-blank meeting-shortcut-icon"
            [adaptBlockingClick]="editMeetingAgenda"
            [adaptBlockingClickParam]="meeting"
            data-test="edit-agenda-button"
            [adaptTooltip]="!showText ? 'Edit agenda' : ''">
        <span *ngIf="showText">Edit agenda</span>
    </button>
</div>
